export default "__VITE_ASSET__CLuq7CMq__"